var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashed",class:{'shorted': _vm.label.length > 15}},[_c('div',{staticClass:"left"},[_vm._v(_vm._s(_vm.item.label))]),_c('div',{staticClass:"center"}),_c('div',{staticClass:"right"},[(_vm.item.link)?_c('a',{staticClass:"shorted",attrs:{"href":_vm.item.link}},[_vm._v(_vm._s(_vm.label))]):[_vm._v(_vm._s(_vm.label))]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }